import * as Sentry from '@sentry/react';
import { readEnv, getMode } from './common';

let initialized = false;

/**
 * Boots the Sentry browser SDK once per page load. No-ops when
 * VITE_SENTRY_DSN is unset, so local dev/CI builds without a DSN configured
 * behave exactly as before this was added.
 */
export const initSentry = () => {
  if (initialized) return;
  const dsn = readEnv('SENTRY_DSN');
  if (!dsn) return;
  initialized = true;
  Sentry.init({
    dsn,
    environment: getMode(),
    integrations: [Sentry.browserTracingIntegration()],
    // Sample every trace outside prod; keep prod volume (and Sentry quota) down.
    tracesSampleRate: getMode() === 'main' ? 0.2 : 1.0,
  });
};

export { Sentry };
